import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { log, errorMsg, refreshToken } from 'utils';
import { getCsrf } from 'components/Report/utils';

export const ORGANIZATIONS_FETCH_DATA_INIT = createAction(
  'ORGANIZATIONS_FETCH_DATA_INIT'
);
export const ORGANIZATIONS_FETCH_DATA_SUCCESS = createAction(
  'ORGANIZATIONS_FETCH_DATA_SUCCESS'
);
export const ORGANIZATIONS_FETCH_DATA_FAIL = createAction(
  'ORGANIZATIONS_FETCH_DATA_FAIL'
);

export const ORGANIZATIONS_DELETE_ORGANIZATION_INIT = createAction(
  'ORGANIZATIONS_DELETE_ORGANIZATION_INIT'
);
export const ORGANIZATIONS_DELETE_ORGANIZATION_SUCCESS = createAction(
  'ORGANIZATIONS_DELETE_ORGANIZATION_SUCCESS'
);
export const ORGANIZATIONS_DELETE_ORGANIZATION_FAIL = createAction(
  'ORGANIZATIONS_DELETE_ORGANIZATION_FAIL'
);

export const ORGANIZATIONS_CLEAR_DATA = createAction(
  'ORGANIZATIONS_CLEAR_DATA'
);

export const ORGANIZATIONS_CREATE_ORGANIZATION_INIT = createAction(
  'ORGANIZATIONS_CREATE_ORGANIZATION_INIT'
);
export const ORGANIZATIONS_CREATE_ORGANIZATION_SUCCESS = createAction(
  'ORGANIZATIONS_CREATE_ORGANIZATION_SUCCESS'
);
export const ORGANIZATIONS_CREATE_ORGANIZATION_FAIL = createAction(
  'ORGANIZATIONS_CREATE_ORGANIZATION_FAIL'
);

export const ORGANIZATIONS_MODIFY_ORGANIZATION_INIT = createAction(
  'ORGANIZATIONS_MODIFY_ORGANIZATION_INIT'
);
export const ORGANIZATIONS_MODIFY_ORGANIZATION_SUCCESS = createAction(
  'ORGANIZATIONS_MODIFY_ORGANIZATION_SUCCESS'
);
export const ORGANIZATIONS_MODIFY_ORGANIZATION_FAIL = createAction(
  'ORGANIZATIONS_MODIFY_ORGANIZATION_FAIL'
);

export const ORGANIZATIONS_CLEAN_UP = createAction('ORGANIZATIONS_CLEAN_UP');

export const ORGANIZATIONS_CLEAR_DATA_LOGOUT = createAction(
  'ORGANIZATIONS_CLEAR_DATA_LOGOUT'
);

axios.defaults.withCredentials = true;

export const fetchOrganizations = (organizationId = '') => {
  return async (dispatch, getState) => {
    dispatch(ORGANIZATIONS_FETCH_DATA_INIT());
    log(organizationId);
    if (organizationId) {
      let organizationData;
      try {
        const token = await refreshToken();
        const res = await axios.post(
          `${url}/organization/get`,
          {
            id: organizationId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        organizationData = res.data.data;
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(ORGANIZATIONS_FETCH_DATA_FAIL({ error }));
      }

      const organization = { ...organizationData, id: organizationId };
      log(organization);
      log(organizationData);
      return dispatch(
        ORGANIZATIONS_FETCH_DATA_SUCCESS({
          list: getState().organizations.list,
          organization: organization,
        })
      );
    }

    const uid = getState().users.user.id; //localStorage.getItem('uid');

    let organizations;

    try {
      const token = await refreshToken();
      const res = await axios.get(`${url}/organization/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      organizations = res.data.data;
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(ORGANIZATIONS_FETCH_DATA_FAIL({ error }));
    }

    const organizationsData = organizations
      ? Object.entries(organizations).map(([key, value]) => ({
          id: key,
          ...value,
        }))
      : [];

    return dispatch(
      ORGANIZATIONS_FETCH_DATA_SUCCESS({
        list: organizationsData.filter(
          (organization) => organization.id !== uid
        ),
        organization: getState().organizations.organization,
      })
    );
  };
};

export const deleteOrganization = (id) => {
  return async (dispatch) => {
    dispatch(ORGANIZATIONS_DELETE_ORGANIZATION_INIT());

    try {
      const csrfToken = await getCsrf();
      const token = await refreshToken();
      await axios.delete(`${url}/organization/delete`, {
        params: {
          id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRF-TOKEN': csrfToken,
        },
        withCredentials: true,
      });
    } catch (error) {
      log(error);
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        ORGANIZATIONS_DELETE_ORGANIZATION_FAIL({
          error: errorMessage,
        })
      );
    }

    toastr.success('', 'The organization was deleted.');
    return dispatch(ORGANIZATIONS_DELETE_ORGANIZATION_SUCCESS({ id }));
  };
};

export const createOrganization = ({
  name,
  description,
  organizationId,
  organizationName,
  modifiedAt,
  modifiedBy,
}) => {
  return async (dispatch, getState) => {
    dispatch(ORGANIZATIONS_CREATE_ORGANIZATION_INIT());

    const organization = {
      name: name,
      description: description,
      organizationId: organizationId,
      organizationName: organizationName,
      modifiedAt: modifiedAt,
      modifiedBy: modifiedBy,
    };

    try {
      const csrfToken = await getCsrf();
      const token = await refreshToken();
      await axios.post(`${url}/organization/create`, organization, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRF-TOKEN': csrfToken,
        },
        withCredentials: true,
      });
    } catch (error) {
      log(error);
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        ORGANIZATIONS_CREATE_ORGANIZATION_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'organization created successfully');
    return dispatch(
      ORGANIZATIONS_CREATE_ORGANIZATION_SUCCESS({ organization: organization })
    );
  };
};

export const modifyOrganization = ({
  name,
  description,
  organizationId,
  organizationName,
  id,
}) => {
  return async (dispatch) => {
    dispatch(ORGANIZATIONS_MODIFY_ORGANIZATION_INIT());

    const organizationData = {
      name: name,
      description: description,
      organizationId: organizationId,
      organizationName: organizationName,
    };

    try {
      const csrfToken = await getCsrf();
      const token = await refreshToken();
      await axios.post(`${url}/organization/${id}`, organizationData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRF-TOKEN': csrfToken,
        },
        withCredentials: true,
      });
    } catch (error) {
      log(error);
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        ORGANIZATIONS_MODIFY_ORGANIZATION_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Organization updated successfully');

    return dispatch(
      ORGANIZATIONS_MODIFY_ORGANIZATION_SUCCESS({
        organization: organizationData,
        id,
      })
    );
  };
};

export const organizationsCleanUp = () => (dispatch) =>
  dispatch(ORGANIZATIONS_CLEAN_UP());
